import { InformarcionTempEntry } from "./../../../../../../shared/entrys/InformarcionTemp.entry";
import { OtraSolicitudEntry } from "./../../../../../../shared/entrys/otra-solicitud.entry";
import { environment } from "../../../../../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable, of } from "rxjs";
import { retry } from "rxjs/operators";
import { RNTOtrasSolicitudEntry } from "./../../../../../../shared/entrys/RNTOtrasSolicitudEntry.entry";
import { EstablecimientoTempEntry } from "src/app/shared/entrys/EstablecimientoTemp.entry";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { AccionesPagoFonturRntEntry , ValidarPagoFonturResponse} from "src/app/shared/entrys/aciones-pago-fontur-rnt.entry";

@Injectable()
export default class OtrasSolicitudesService
  implements RequestCRUD<RNTOtrasSolicitudEntry, ResponseServiceModel>
{
  private API_URL;
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.handleError = httpErrorHandler.createHandleError("OtrasSolicitudes");
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: RNTOtrasSolicitudEntry): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/Establecimiento`)
      .pipe(retry(2));
  }
  update(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/${entry.solicitud_id}`,
        entry
      )
      .pipe(retry(2));
  }
  createSuspension(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/CrearSuspension`,
        entry
      )
      .pipe(retry(2));
  }
  createCancelacion(
    entry: RNTOtrasSolicitudEntry
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/CrearCancelacion`,
        entry
      )
      .pipe(retry(2));
  }

  create(entry: RNTOtrasSolicitudEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  delete(entry: RNTOtrasSolicitudEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  createEdicion(
    entry: RNTOtrasSolicitudEntry
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/CreaSolicitudEdicion`,
        entry
      )
      .pipe(retry(2));
  }
  sendNotificar(entry: any) {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/AsignarFuncionario`,
        entry
      )
      .pipe(retry(2));
  }
  getInformacionTemp(
    entry: EstablecimientoTempEntry
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/Establecimiento`, entry)
      .pipe(retry(2));
  }
  updateInformacionTemp(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/ActualizaSolicitudEdicionInformacion`,
        entry
      )
      .pipe(retry(2));
  }
  uploadFile(entry: any): Observable<HttpEvent<any>> {
    const input = new FormData();
    input.append("archivo", entry.file_to_upload, entry.file_to_upload.name);
    const uploadReq = new HttpRequest(
      "POST",
      `${this.API_URL}/Archivo/SubirDocumento/${entry.codigo_camara}/${entry.detalle_solicitud_id}`,
      input,
      {
        reportProgress: true,
      }
    );
    return this.http.request<HttpEvent<any>>(uploadReq).pipe(retry(2));
  }

  dropUploadFile(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Archivo/EliminarDocumento/${entry.codigo_camara}/${entry.detalle_solicitud_id}`,
        entry
      )
      .pipe(retry(2));
  }

  createReactivacion(
    entry: RNTOtrasSolicitudEntry
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/CrearReactivacion`,
        entry
      )
      .pipe(retry(2));
  }


  getDocumentoReactivacion(
    entry: RNTOtrasSolicitudEntry
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/DocumentoDetalleSolicitud/ObtenerPorDetalleSolicitud`,
        entry
      )
      .pipe(retry(2));
  }

  getParametro(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Parametro/DetallePorId`,
        entry
      )
      .pipe(retry(2));
  }

  getOmitirDocumento(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/OmitirDocumento`,
        entry
      )
      .pipe(retry(2));
  }

  descargarDocumento(entry: any): Observable<Blob> {
    return this.http
      .post<Blob>(
        `${this.API_URL}/DocumentoDetalleSolicitud/DescargarDocumento`,
        entry
      )
      .pipe(retry(2));
  }


  ValidarPagoFontur(entry:AccionesPagoFonturRntEntry): Observable<ValidarPagoFonturResponse> {
    return this.http
      .post<ValidarPagoFonturResponse>(
        `${this.API_URL}/Fontur/GetPagoMulta`,
        entry
      )
      .pipe(retry(2));
  }

  UpdatePagoFontur(entry:any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Fontur/UpdatePagoMulta`,
        entry
      )
      .pipe(retry(2));
  }
}


